import {
  FETCH_PAYMENT_TYPES,
  FETCH_PAYMENT_TYPES_SUCCESS,
} from "../constants/payementType.constants";

export const getPayementTypes = (page) => {
  return {
    type: FETCH_PAYMENT_TYPES,
    page: page,
  };
};

export const getPayementTypesSuccess = (payment_types) => {
  return {
    type: FETCH_PAYMENT_TYPES_SUCCESS,
    payment_types: payment_types,
  };
};
